export default __webpack_public_path__ + "static/media/6-sgi-matricula-v2.0e6f82cb.png";